import { Button, Modal, ModalBody, ModalHeader } from "design-react-kit";

const EmailSentModal = ({ modalOpen, modalCloseHandler, message }) => {
  return (
    <Modal isOpen={modalOpen} toggle={modalCloseHandler} align="center">
      <ModalHeader className="text-center text-lowercase">
        Email Inviata
      </ModalHeader>
      <ModalBody>
        <p className="mb-4">{message}</p>
        <div className="col-sm-12 mb-2 d-flex align-items-center justify-content-end">
          <Button
            color="primary"
            id="user-save"
            onClick={(e) => modalCloseHandler()}
          >
            Chiudi
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default EmailSentModal;
